export { buildFacetFiltersFromRefinements } from './buildFacetFiltersFromRefinements'
export { getAutocompleteIndices } from './getAutocompleteIndices'
export { getFacetSectionKey } from './getFacetSectionKey'
export { getFacetsForLocale } from './getFacetsForLocale'
export { normalizeAutocompleteLanguageCode } from './normalizeAutocompleteLanguageCode'
export { shouldFetchAutocompleteForQuery } from './shouldFetchAutocompleteForQuery'
export { shouldShowCuratedAutocompleteSections } from './shouldShowCuratedAutocompleteSections'
